import React from 'react';

type HomeSectionContainerProps = {
  headerLabel: string;
  title?: string | null;
  description?: string | null;
  children: React.ReactNode;
};

export default function HomeSectionContainer({ headerLabel, title, description, children }: HomeSectionContainerProps) {
  return (
    <div className="mt-20">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-center gap-6 px-4 sm:px-6">
        <div className="flex w-full items-center justify-center">
          <div className="text-lg sm:text-xl font-semibold text-[#113D7B] break-words text-center">{headerLabel}</div>
        </div>

        {title && <div className="text-2xl sm:text-3xl font-medium text-black break-words text-center">{title}</div>}

        {description && (
          <div className="text-center flex w-full justify-center">
            <div className="text-base sm:text-lg font-medium text-black break-words w-full text-center max-w-5xl">
              {description}
            </div>
          </div>
        )}

        <div>{children}</div>
      </div>
    </div>
  );
}
